import React, { useEffect, useRef, useState } from 'react';

const DataFlow = ({ pathElement, containerRef, active = true }) => {
  const [particles, setParticles] = useState([]);
  const animationRef = useRef();

  useEffect(() => {
    if (!active || !pathElement || !containerRef.current) return;

    const createParticle = () => ({
      id: Math.random(),
      progress: 0,
      speed: 0.005 + Math.random() * 0.01, // Random speed
      size: (2 + Math.random() * 3) * 1.2,
      opacity: 0.8 + Math.random() * 0.2,
      color: 'white'
    });

    const spawnParticle = () => {
      if (Math.random() < 0.01) { // 1% chance per frame to spawn
        setParticles(prev => [...prev, createParticle()]);
      }
    };

    const animate = () => {
      spawnParticle();
      
      setParticles(prev => prev
        .map(particle => ({
          ...particle,
          progress: particle.progress + particle.speed
        }))
        .filter(particle => particle.progress <= 1) // Remove completed particles
      );

      animationRef.current = requestAnimationFrame(animate);
    };

    animate();

    return () => {
      if (animationRef.current) {
        cancelAnimationFrame(animationRef.current);
      }
    };
  }, [active, pathElement, containerRef]);

  const getPointAtProgress = (progress) => {
    if (!pathElement) return { x: 0, y: 0 };
    
    const pathLength = pathElement.getTotalLength();
    const point = pathElement.getPointAtLength(progress * pathLength);
    
    // The point is already in SVG coordinates, which match the FlowContainer coordinates
    // No need for coordinate transformation since both are relative to the same container
    return {
      x: point.x,
      y: point.y
    };
  };

  return (
    <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', pointerEvents: 'none' }}>
      {particles.map(particle => {
        const position = getPointAtProgress(particle.progress);
        return (
          <div
            key={particle.id}
            style={{
              position: 'absolute',
              left: position.x,
              top: position.y,
              width: particle.size,
              height: particle.size,
              borderRadius: '50%',
              backgroundColor: particle.color,
              opacity: particle.opacity * (1 - particle.progress), // Fade out as it travels
              boxShadow: `0 0 ${particle.size * 2}px ${particle.color}`,
              transform: 'translate(-50%, -50%)',
              zIndex: 5
            }}
          />
        );
      })}
    </div>
  );
};

export default DataFlow;